export const categoryOptions = [
    { value: "Amendment", label: "Amendment" },
    { value: "FBAR", label: "FBAR" },
    { value: "FATCA", label: "FATCA" },
    { value: "FICA", label: "FICA" },
    { value: "Audit", label: "Audit" },
    { value: "Tax Queries", label: "Tax Queries" },
  ]

export const reopenLeadContext = {
    reOpenStatus: "1",
    category:"",
    reOpenComments: ""
  }